module.exports = __webpack_public_path__ + "img/25.5f0fec44.png";